export default __webpack_public_path__ + "static/media/export.0e5ecb37.svg";